import { getCountryList } from "@/actions/defaultDataAction";
import { getAllAdminInquiries } from "@/actions/inquiryAction";
import { hideLoading, showLoading } from "@/actions/loaderAction";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import SubHeader from "../SubHeader";
import { find, isArray, isEmpty, isString, map, size } from "lodash";
import {
  buildPath,
  getPrefix,
  setAuthHeaders,
  showSuccessMessage,
} from "@/utils/common";
import { privateRoutePaths } from "@/routes/private.route.config";
import CheckBox from "../CheckBox";
import Select from "react-select";
import ToolipsCustom from "../ToolipsCustom";
import RadioButtonField from "../RadioButtonField";
import { getCompaniesByCountry } from "@/actions/memberAction";
import axiosHttp from "@/axiosHttp";
import API_URL from "@/constant/api.config";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "@/AuthProvider";
import defaultValues from "@/constant/defaultValues";

const LogisticInqViewPage = (props) => {
  const { id } = useParams();
  const { user } = useAuth();
  const headers = setAuthHeaders();
  const showPickupAddress = [
    "EXW (Ex-Works or Ex-Warehouse)",
    "FCA (Free to Carrier)",
  ];
  const showDeliveryAddress = [
    "CPT (Carriage Paid To)",
    "CIP (Carriage And Insurance Paid To)",
    "DAP (Delivered At Place)",
    "DDP (Delivered Duty Paid)",
  ];

  const { IMAGE_PATH } = defaultValues;
  const PATH = IMAGE_PATH.BASE_URL;

  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [search_country, setSearchCountry] = useState(null);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [assignedCompanyAndCountry, setAssignedCompanyAndCountry] = useState([]);
  const [memberOptLoader, setMemberOptLoader] = useState(false);

  const [formData, setFormData] = useState({
    country_assign: "",
    company_obj: "",
  });

  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setisButtonDisabled] = useState(false);

  const customFilter = (option, searchTxt) => {
    const label = option.data.label?.toLowerCase() ?? "";
    const email = option.data.email?.toLowerCase() ?? "";
    const query = searchTxt.toLowerCase();

    return label.includes(query) || email.includes(query);
  };

  const handleAssignCountryChangeByIndex = async (val) => {
    let inqPage = props.inq_type ?? null;
    let payload = {
      country: val.value,
      inquiry_for: "LOG_PTR",
      search: "NO",
      inqPage: inqPage,
      c_status: selectedUserType,
    };

    setSearchCountry(val);

    await props
      .getCompaniesByCountry(payload)
      .then((data) => {
        const options = map(data, (v) => ({
          value: v.id,
          label: v.company_list_name,
          email: v.email ?? "",
          paid_status: v.paid_status,
          inq_count: v.inq_count,
        })).slice(0, 10);

        setCompanyOptions(options);
      })
      .catch((err) => {
        console.log("Error :", err);
      });
  };

  const handleMenuClose = () => {
    if(search_country) {
      handleAssignCountryChangeByIndex(search_country);
    } 
  }

  const handleAssignCompanyInputChange = (newValue) => {
    let inqPage = props.inq_type ?? null;
    console.log("bbbbbbbbbbbbbbbbbbb", newValue);
    if (newValue !== "" && search_country) {
      let inquiry_for = "LOG_PTR";
      const headers = setAuthHeaders();
      if (newValue.length >= 3) {
        setMemberOptLoader(true);
        setCompanyOptions([]);
        axiosHttp
          .post(
            API_URL + "/get-company",
            {
              search_txt: newValue,
              country: search_country.country_id,
              inquiry_for: inquiry_for,
              search: "YES",
              inqPage: inqPage,
              c_status: selectedUserType,
            },
            { headers }
          )
          .then((response) => {
            if (response.status === 200 && response.data.status === true) {
              if (!isEmpty(response.data.data)) {
                const options = response.data.data.map((ct) => ({
                  value: ct.id,
                  label: ct.company_list_name,
                  email: ct.email,
                  paid_status: ct.paid_status,
                  inq_count: ct.inq_count,
                }));
                setCompanyOptions(options);
                setMemberOptLoader(false);
              } else {
                axiosHttp
                  .post(
                    API_URL + "/get-company",
                    {
                      country: search_country.label,
                      inquiry_for: inquiry_for,
                      search: "NO",
                      inqPage: inqPage,
                      c_status: selectedUserType,
                    },
                    { headers }
                  )
                  .then((response) => {
                    if (response.status === 200) {
                      setMemberOptLoader(false);
                      if (response.data.status === true) {
                        const options = response.data.data.map((ct) => ({
                          value: ct.id,
                          label: ct.company_list_name,
                          email: ct.email,
                          paid_status: ct.paid_status,
                          inq_count: ct.inq_count,
                        }));
                        setCompanyOptions(options);
                      }
                    }
                  })
                  .catch((err) => console.log("Error : ", err));
              }
            }
          });
      }
    }
  };

  const handleCompanySelect = (option) => {
    if (!option || !search_country) return;

    const countryId = search_country.country_id ?? search_country.value;

    const entry = {
      value: option.value,
      paid_status: option.paid_status,
      inq_count: option.inq_count,
      assign_tomembers: {
        id: option.value,
        company_name: option.label,
        email: option.email,
        country_id: countryId,
      },
      isNew: true,
      assign_to: option.value,
    };

    const current = (assignedCompanyAndCountry || []).filter(
      (c) => c && c.assign_tomembers
    );

    const exists = current.some(
      (c) =>
        String(c.assign_tomembers.id) === String(entry.assign_tomembers.id) &&
        String(c.assign_tomembers.country_id) === String(countryId)
    );

    if (exists) return;

    const updated = [...current, entry];
    setAssignedCompanyAndCountry(updated);
    setFormData((prev) => ({ ...prev, company_obj: updated }));
  };

  const handleRadioBtnChange = (val) => {
    setSelectedUserType(val);
    setSearchCountry(null);
    setCompanyOptions([]);
  };

  const fetchCountries = async () => {
    await props
      .getCountryList()
      .then((response) => {
        let countryOptions = map(response, (country) => ({
          value: country.name,
          label: country.name,
          countryCode: country.iso2,
          country_id: country.id,
        }));
        setCountryList(countryOptions);
      })
      .catch((err) => console.log("Error :", err));
  };

  const validation = () => true;

  const handleRemoveCompany = (index) => {
    const updated = (assignedCompanyAndCountry || []).filter(
      (_, i) => i !== index
    );
    setAssignedCompanyAndCountry(updated);
    setFormData((prev) => ({ ...prev, company_obj: updated }));
  };

  const fetchInquiry = async (idVal) => {
    const searchFilterObj = {
      filter_val: idVal,
      findWhom: "All",
      inq_type: "All",
      selected_country: null,
      startDate: null,
      endDate: null,
      assign_to_member: 0,
    };
    await props
      .getAllInquiries(1, 1, searchFilterObj)
      .then((response) => {
        if (response?.status && response?.data) {
          console.log("============================ ", response.data[0].assign_to);
          setSelectedInquiry(response.data[0]);
          setAssignedCompanyAndCountry(response.data[0].assign_to);
          setFormData((prev) => {
            return {
              ...prev,
              company_obj: response.data[0].assign_to
            }
          })
        }
      })
      .catch((err) => console.log("Error :", err));
  };

  const handleDownload = (filename) => {
    const link = document.createElement("a");
    link.href = filename;
    link.download = filename;
    link.target = "_blank";
    link.click();
  };

  const handleInquirySubmit = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setisButtonDisabled(true);
        await axiosHttp
          .post(
            API_URL + "/assign-company-inquiry",
            { formData, selectedInquiry },
            { headers }
          )
          .then((response) => {
            if (response.data.status === true) {
              fetchInquiry(id);
              setTimeout(() => setisButtonDisabled(false), 1000);
              showSuccessMessage("Inquiry Assign Successfully!");
            } else {
              setisButtonDisabled(false);
              setErrors(response.data.error || {});
            }
          })
          .catch((error) => {
            setisButtonDisabled(false);
            console.error("Error fetching data:", error);
          });
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchInquiry(id);
  }, [id]);

  return (
    <div className="company-main">
      <SubHeader
        layer1="Logistic Inquiries"
        layer2="List"
        layer3="View"
        pageName="View Inquiry"
        clickable={{
          layer1: `/${getPrefix(user)}${buildPath(privateRoutePaths.LOGISTIC_INQUIRIES, { fordate: "" })}`,
          layer2: "",
          layer3: "",
        }}
      />

      <form onSubmit={handleInquirySubmit}>
        <div className="company-info-details new-design">
          <div className="row">
            {/* ================= LEFT COLUMN ================= */}
            <div className="col-xxl-7 col-xl-7 col-lg-7">
              {/* ---------- From card ---------- */}
              <div className="card mb-3">
                <div className="company-card company-card-info">
                  <div className="naming-wrape">
                    <div className="naming-pad">
                      <h3>From</h3>
                    </div>
                  </div>
                  <div className="middle-wrape">
                    <div className="row">
                      {selectedInquiry?.company_name && (
                        <>
                          <div className="col-xl-6 gx-4">
                            <p className="inquiry-detials-info">
                              <span>Company Name:</span>{" "}
                              {!isEmpty(selectedInquiry.assign_from) &&
                              selectedInquiry.assign_from[0]?.assign_from ? (
                                <Link
                                  to={`/${getPrefix(user)}${buildPath(
                                    privateRoutePaths.VIEW_COMPANY_PROFILE,
                                    {
                                      id: selectedInquiry.assign_from[0]
                                        .assign_from,
                                    },
                                  )}`}
                                  target="_blank"
                                >
                                  {selectedInquiry.company_name}
                                </Link>
                              ) : (
                                <>{selectedInquiry.company_name}</>
                              )}
                            </p>
                          </div>
                          <div className="col-xl-6 gx-4">
                            <p>
                              <span>Contact Person:</span>{" "}
                              {selectedInquiry.contact_person}
                            </p>
                          </div>
                          <div className="col-xl-6 gx-4">
                            <p>
                              <span>Email:</span> {selectedInquiry.email}
                              {selectedInquiry.other_email
                                ? `, ${selectedInquiry.other_email}`
                                : ""}
                            </p>
                          </div>
                          <div className="col-xl-6 gx-4">
                            <p>
                              <span>Phone Number:</span>{" "}
                              {!isEmpty(selectedInquiry.phone)
                                ? selectedInquiry.phone
                                : " - "}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* ---------- Inquiry Information card ---------- */}
              <div className="card mb-3">
                <div className="company-card company-card-info">
                  <div className="naming-wrape">
                    <div className="naming-pad">
                      <h3>Inquiry information</h3>
                    </div>
                  </div>
                  <div className="middle-wrape">
                    <div className="row">
                      {selectedInquiry && (
                        <div className="col-xl-4 gx-4">
                          <p>
                            <span>Inquiry ID:</span>{" "}
                            {!isEmpty(selectedInquiry.inquiry_unique_id)
                              ? selectedInquiry.inquiry_unique_id
                              : " - "}
                          </p>
                        </div>
                      )}

                      {/* ---------------- AIR ---------------- */}
                      {selectedInquiry?.type === "Logistic_Partner" &&
                        selectedInquiry?.freight_type === "Air" && (
                          <>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Freight type:</span>{" "}
                                {selectedInquiry.freight_type}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Origin Country:</span>{" "}
                                {selectedInquiry.country_from}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Origin Airport:</span>{" "}
                                {selectedInquiry.port_of_origin}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Destination Country:</span>{" "}
                                {selectedInquiry.country_to}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Destination Airport:</span>{" "}
                                {selectedInquiry.port_of_destination}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Commodity/Product:</span>{" "}
                                {selectedInquiry.commodity}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Hs Code:</span>{" "}
                                {!isEmpty(selectedInquiry.hs_code)
                                  ? `${selectedInquiry.hs_code} `
                                  : "-"}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4"></div>
                            {/* L/W/H + No/Qty + Packaging table */}
                            <div className="col-xl-12 gx-4">
                              <div className="air-table-wrap">
                                <table className="air-table">
                                  <thead>
                                    <tr>
                                      <th>Length/Width/Height (CM):</th>
                                      <th>No/Qty:</th>
                                      <th>Type of Packaging:</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      // <-- Opened function block
                                      let parsedLwh = null;
                                      try {
                                        parsedLwh = selectedInquiry.lwh
                                          ? JSON.parse(selectedInquiry.lwh)
                                          : null;
                                      } catch (e) {
                                        parsedLwh = selectedInquiry.lwh;
                                      }

                                      let parsedContainers = null;
                                      let parsedCbpp = null;
                                      try {
                                        parsedContainers =
                                          selectedInquiry.no_of_containers
                                            ? JSON.parse(
                                                selectedInquiry.no_of_containers,
                                              )
                                            : null;
                                        parsedCbpp = selectedInquiry.cbpp
                                          ? JSON.parse(selectedInquiry.cbpp)
                                          : null;
                                      } catch (e) {
                                        parsedContainers =
                                          selectedInquiry.no_of_containers;
                                        parsedCbpp = selectedInquiry.cbpp;
                                      }

                                      // FIXED: Added 'return' before the map execution so it actually outputs to the screen
                                      if (
                                        isArray(parsedLwh) &&
                                        isArray(parsedCbpp)
                                      ) {
                                        return map(parsedLwh, (val, key) => (
                                          <tr key={key}>
                                            <td>{val}</td>
                                            <td>
                                              {parsedContainers &&
                                                parsedContainers[key]}
                                            </td>
                                            <td>
                                              {parsedCbpp && parsedCbpp[key]}
                                            </td>
                                          </tr>
                                        ));
                                      }

                                      if (
                                        typeof parsedLwh === "string" &&
                                        parsedLwh.trim() !== ""
                                      ) {
                                        return (
                                          <tr>
                                            <td>{parsedLwh}</td>
                                            <td>{parsedContainers || "-"}</td>
                                            <td>{parsedCbpp || "-"}</td>
                                          </tr>
                                        );
                                      }

                                      return (
                                        <tr>
                                          <td colSpan={3}>-</td>
                                        </tr>
                                      );
                                    })()}{" "}
                                    {/* <-- FIXED: Added () here so the function self-executes immediately */}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Total Weight (KG):</span>{" "}
                                {!isEmpty(selectedInquiry.total_weight)
                                  ? selectedInquiry.total_weight
                                  : " - "}
                              </p>
                            </div>
                            {selectedInquiry.term && (
                              <div className="col-xl-4 gx-4">
                                <p>
                                  <span>Term:</span> {selectedInquiry.term}
                                </p>
                              </div>
                            )}

                            {!isEmpty(selectedInquiry.term) &&
                              showPickupAddress.includes(
                                selectedInquiry.term,
                              ) && (
                                <div className="col-xl-4 gx-4">
                                  <p>
                                    <span>Pickup Address:</span>{" "}
                                    {selectedInquiry.pickup_address}
                                  </p>
                                </div>
                              )}
                            {((!isEmpty(selectedInquiry.term) &&
                              showDeliveryAddress.includes(
                                selectedInquiry.term,
                              )) ||
                              selectedInquiry.freight_type === "DAP") && (
                              <div className="col-xl-4 gx-4">
                                <p>
                                  <span>Delivery Address:</span>{" "}
                                  {selectedInquiry.delivery_address}
                                </p>
                              </div>
                            )}
                            <div className="col-xl-12 gx-4 ck-edit-cntnt">
                              <div
                                className="border-0 inq-message"
                                dangerouslySetInnerHTML={{
                                  __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><span>Remark:</span> ${
                                    !isEmpty(selectedInquiry.message)
                                      ? selectedInquiry.message
                                      : " - "
                                  }</p>`,
                                }}
                              />
                            </div>
                          </>
                        )}

                      {/* ---------------- ROAD ---------------- */}
                      {selectedInquiry?.type === "Logistic_Partner" &&
                        selectedInquiry?.freight_type === "Road" && (
                          <>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Freight type:</span> Road Transportation
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Cargo type:</span>{" "}
                                {selectedInquiry.ocean_type}{" "}
                                {selectedInquiry.ocean_type == "FTL"
                                  ? "(Full Truck Load)"
                                  : "(Less Truck Load)"}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Country From:</span>{" "}
                                {selectedInquiry.country_from
                                  ? selectedInquiry.country_from
                                  : "-"}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Origin Port:</span>{" "}
                                {selectedInquiry.port_of_origin
                                  ? selectedInquiry.port_of_origin
                                  : "-"}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Country To:</span>{" "}
                                {selectedInquiry.country_to
                                  ? selectedInquiry.country_to
                                  : "-"}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Destination Port:</span>{" "}
                                {selectedInquiry.port_of_destination
                                  ? selectedInquiry.port_of_destination
                                  : "-"}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Commodity/Product: </span>{" "}
                                {selectedInquiry.commodity}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Hs Code:</span>{" "}
                                {!isEmpty(selectedInquiry.hs_code)
                                  ? `${selectedInquiry.hs_code} `
                                  : "-"}
                              </p>
                            </div>

                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>No of Containers/Vehicles:</span>

                                {selectedInquiry.no_of_containers &&
                                  selectedInquiry.no_of_containers}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Containers Type:</span>
                                {selectedInquiry.cbpp && selectedInquiry.cbpp}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Total Weight (KG):</span>{" "}
                                {!isEmpty(selectedInquiry.total_weight)
                                  ? selectedInquiry.total_weight
                                  : " - "}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Term:</span>{" "}
                                {selectedInquiry.term
                                  ? selectedInquiry.term
                                  : "-"}
                              </p>
                            </div>
                            {!isEmpty(selectedInquiry.term) &&
                              showPickupAddress.includes(
                                selectedInquiry.term,
                              ) && (
                                <div className="col-xl-4 gx-4">
                                  <p>
                                    <span>Pickup Address:</span>{" "}
                                    {selectedInquiry.pickup_address}
                                  </p>
                                </div>
                              )}
                            {((!isEmpty(selectedInquiry.term) &&
                              showDeliveryAddress.includes(
                                selectedInquiry.term,
                              )) ||
                              selectedInquiry.freight_type === "DAP") && (
                              <div className="col-xl-4 gx-4">
                                <p>
                                  <span>Delivery Address:</span>{" "}
                                  {selectedInquiry.delivery_address}
                                </p>
                              </div>
                            )}
                            <div className="col-xl-12 gx-4 ck-edit-cntnt">
                              <div
                                className="border-0 inq-message"
                                dangerouslySetInnerHTML={{
                                  __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><span>Remark:</span> ${
                                    !isEmpty(selectedInquiry.message)
                                      ? selectedInquiry.message
                                      : " - "
                                  }</p>`,
                                }}
                              />
                            </div>
                          </>
                        )}

                      {/* ---------------- DAP ---------------- */}
                      {selectedInquiry?.type === "Logistic_Partner" &&
                        selectedInquiry?.freight_type === "DAP" && (
                          <>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Freight type:</span> DAP Services
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Cargo type:</span>{" "}
                                {selectedInquiry.ocean_type == "Project_Cargo"
                                  ? "Project Cargo"
                                  : selectedInquiry.ocean_type == "DAG_GOODS"
                                    ? "Dangerous Goods"
                                    : selectedInquiry.ocean_type == "LCL_FCL"
                                      ? "LCL & FCL Both"
                                      : selectedInquiry.ocean_type}{" "}
                                {selectedInquiry.ocean_type == "FCL"
                                  ? "(Full Container Load)"
                                  : ""}
                                {selectedInquiry.ocean_type == "LCL"
                                  ? "(Less Container Load)"
                                  : ""}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Country:</span>{" "}
                                {selectedInquiry.country_from}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Port:</span>{" "}
                                {selectedInquiry.port_of_origin}
                              </p>
                            </div>

                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>
                                  {" "}
                                  {selectedInquiry.ocean_type == "Ro-Ro"
                                    ? "Commodity/Product"
                                    : "Commodity"}
                                  :{" "}
                                </span>{" "}
                                {selectedInquiry.commodity}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Hs Code:</span>{" "}
                                {!isEmpty(selectedInquiry.hs_code)
                                  ? `${selectedInquiry.hs_code} `
                                  : "-"}
                              </p>
                            </div>

                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>
                                  {selectedInquiry.ocean_type == "FCL" ||
                                  selectedInquiry.ocean_type == "LCL" ||
                                  selectedInquiry.ocean_type == "DAG_GOODS"
                                    ? "No of Containers: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "Ro-Ro"
                                    ? "No of Units: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "Project_Cargo"
                                    ? "No of Pieces: "
                                    : ""}
                                </span>

                                {selectedInquiry.no_of_containers
                                  ? selectedInquiry.no_of_containers
                                  : "-"}
                              </p>
                            </div>
                            {selectedInquiry.ocean_type != "Ro-Ro" &&
                              selectedInquiry.ocean_type != "Project_Cargo" && (
                                <div className="col-xl-4 gx-4">
                                  <p>
                                    <span>
                                      {selectedInquiry.ocean_type ==
                                        "DAG_GOODS" ||
                                      selectedInquiry.ocean_type == "LCL"
                                        ? "Type of Packaging: "
                                        : ""}
                                      {selectedInquiry.ocean_type == "FCL"
                                        ? "Type of Container: "
                                        : ""}
                                    </span>
                                    {selectedInquiry.cbpp &&
                                      selectedInquiry.cbpp}
                                  </p>
                                </div>
                              )}

                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Total Weight (KG):</span>{" "}
                                {!isEmpty(selectedInquiry.total_weight)
                                  ? selectedInquiry.total_weight
                                  : " - "}
                              </p>
                            </div>
                            {selectedInquiry.term && (
                              <div className="col-xl-4 gx-4">
                                <p>
                                  <span>Term:</span> {selectedInquiry.term}
                                </p>
                              </div>
                            )}

                            {!isEmpty(selectedInquiry.term) &&
                              showPickupAddress.includes(
                                selectedInquiry.term,
                              ) && (
                                <div className="col-xl-4 gx-4">
                                  <p>
                                    <span>Pickup Address:</span>{" "}
                                    {selectedInquiry.pickup_address}
                                  </p>
                                </div>
                              )}
                            {((!isEmpty(selectedInquiry.term) &&
                              showDeliveryAddress.includes(
                                selectedInquiry.term,
                              )) ||
                              selectedInquiry.freight_type === "DAP") && (
                              <div className="col-xl-4 gx-4">
                                <p>
                                  <span>Delivery Address:</span>{" "}
                                  {selectedInquiry.delivery_address}
                                </p>
                              </div>
                            )}
                            <div className="col-xl-12 gx-4 ck-edit-cntnt">
                              <div
                                className="border-0 inq-message"
                                dangerouslySetInnerHTML={{
                                  __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><span>Remark:</span> ${
                                    !isEmpty(selectedInquiry.message)
                                      ? selectedInquiry.message
                                      : " - "
                                  }</p>`,
                                }}
                              />
                            </div>
                          </>
                        )}

                      {/* ---------------- OCEAN ---------------- */}
                      {selectedInquiry?.type === "Logistic_Partner" &&
                        selectedInquiry?.freight_type === "Ocean" && (
                          <>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Freight type:</span> Sea Freight
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Cargo type:</span>{" "}
                                {selectedInquiry.ocean_type == "Project_Cargo"
                                  ? "Project Cargo"
                                  : selectedInquiry.ocean_type == "DAG_GOODS"
                                    ? "Dangerous Goods"
                                    : selectedInquiry.ocean_type == "LCL_FCL"
                                      ? "LCL & FCL Both"
                                      : selectedInquiry.ocean_type}{" "}
                                {selectedInquiry.ocean_type == "FCL"
                                  ? "(Full Container Load)"
                                  : ""}
                                {selectedInquiry.ocean_type == "LCL"
                                  ? "(Less Container Load)"
                                  : ""}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Country From:</span>{" "}
                                {selectedInquiry.country_from}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Origin Port:</span>{" "}
                                {selectedInquiry.port_of_origin}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Country To:</span>{" "}
                                {selectedInquiry.country_to}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Destination Port:</span>{" "}
                                {selectedInquiry.port_of_destination}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              {selectedInquiry.ocean_type == "Ro-Ro" ||
                              selectedInquiry.ocean_type == "LCL_FCL" ? (
                                <p>
                                  <span>Commodity/Product: </span>{" "}
                                  {selectedInquiry.commodity}
                                </p>
                              ) : (
                                <p>
                                  <span>Commodity: </span>{" "}
                                  {selectedInquiry.commodity}
                                </p>
                              )}
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Hs Code:</span>{" "}
                                {!isEmpty(selectedInquiry.hs_code)
                                  ? `${selectedInquiry.hs_code} `
                                  : "-"}
                              </p>
                            </div>

                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>
                                  {selectedInquiry.ocean_type == "FCL" ||
                                  selectedInquiry.ocean_type == "LCL" ||
                                  selectedInquiry.ocean_type == "DAG_GOODS"
                                    ? "No of Containers: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "Ro-Ro"
                                    ? "No of Units: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "Project_Cargo"
                                    ? "No of Pieces: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "LCL_FCL"
                                    ? "No of Containers: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "Bulk"
                                    ? "Cargo Qty: "
                                    : ""}
                                </span>

                                {selectedInquiry.no_of_containers &&
                                  selectedInquiry.no_of_containers}
                              </p>
                            </div>
                            {selectedInquiry.ocean_type != "Ro-Ro" &&
                              selectedInquiry.ocean_type != "Project_Cargo" && (
                                <div className="col-xl-4 gx-4">
                                  <p>
                                    <span>
                                      {selectedInquiry.ocean_type ==
                                        "DAG_GOODS" ||
                                      selectedInquiry.ocean_type == "LCL" ||
                                      selectedInquiry.ocean_type ==
                                        "Project_Cargo"
                                        ? "Type of Packaging: "
                                        : ""}
                                      {selectedInquiry.ocean_type == "FCL"
                                        ? "Type of Container: "
                                        : ""}
                                      {selectedInquiry.ocean_type == "LCL_FCL"
                                        ? "Type of packaging/container: "
                                        : ""}
                                      {selectedInquiry.ocean_type == "Bulk"
                                        ? "Type of product: "
                                        : ""}
                                    </span>
                                    {selectedInquiry.cbpp &&
                                      selectedInquiry.cbpp}
                                  </p>
                                </div>
                              )}
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Total Weight (KG):</span>{" "}
                                {!isEmpty(selectedInquiry.total_weight)
                                  ? selectedInquiry.total_weight
                                  : " - "}
                              </p>
                            </div>
                            <div className="col-xl-4 gx-4">
                              <p>
                                <span>Term:</span> {selectedInquiry.term}
                              </p>
                            </div>
                            {!isEmpty(selectedInquiry.term) &&
                              showPickupAddress.includes(
                                selectedInquiry.term,
                              ) && (
                                <div className="col-xl-4 gx-4">
                                  <p>
                                    <span>Pickup Address:</span>{" "}
                                    {selectedInquiry.pickup_address}
                                  </p>
                                </div>
                              )}
                            {((!isEmpty(selectedInquiry.term) &&
                              showDeliveryAddress.includes(
                                selectedInquiry.term,
                              )) ||
                              selectedInquiry.freight_type === "DAP") && (
                              <div className="col-xl-4 gx-4">
                                <p>
                                  <span>Delivery Address:</span>{" "}
                                  {selectedInquiry.delivery_address}
                                </p>
                              </div>
                            )}
                            <div className="col-xl-12 gx-4 ck-edit-cntnt">
                              <div
                                className="border-0 inq-message"
                                dangerouslySetInnerHTML={{
                                  __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><span>Remark:</span> ${
                                    !isEmpty(selectedInquiry.message)
                                      ? selectedInquiry.message
                                      : " - "
                                  }</p>`,
                                }}
                              />
                            </div>
                          </>
                        )}

                      {/* ---------------- Attachment Buttons ---------------- */}
                      {selectedInquiry &&
                        (selectedInquiry.doc1 ||
                          selectedInquiry.doc2 ||
                          selectedInquiry.doc3 ||
                          selectedInquiry.doc4 ||
                          selectedInquiry.doc5) && (
                          <div className="col-xl-12 mt-3 mb-3">
                            <div className="d-flex flex-wrap gap-2 attachment-btn-wrape">
                              {[1, 2, 3, 4, 5].map(
                                (num) =>
                                  selectedInquiry[`doc${num}`] && (
                                    <a
                                      key={num}
                                      className="btn btn-primary"
                                      onClick={() =>
                                        handleDownload(
                                          PATH + selectedInquiry[`doc${num}`],
                                        )
                                      }
                                    >
                                      <i className="fa fa-paperclip"></i>{" "}
                                      Attachment {num}
                                    </a>
                                  ),
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= RIGHT COLUMN : Assign Inquiry ================= */}
            <div className="col-xxl-5 col-xl-5 col-lg-5">
              <div className="card">
                <div className="company-card company-card-info">
                  <div className="naming-wrape">
                    <div className="naming-pad">
                      <h3>Assign Inquiry</h3>
                    </div>
                  </div>
                  <div className="middle-wrape">
                    <p className="d-flex align-items-center mt-2 mb-3">
                      <CheckBox checked={true} />
                      <label className="ms-2">Change Assign Inquiry</label>
                    </p>

                    <div className="row">
                      <div className="col-md-12 mb-3 mt-1">
                        <RadioButtonField
                          checked={selectedUserType === ""}
                          onChange={() => handleRadioBtnChange("")}
                        />
                        <label>All</label>
                        <RadioButtonField
                          checked={selectedUserType === "paid"}
                          onChange={() => handleRadioBtnChange("paid")}
                        />
                        <label>Paid</label>
                        <RadioButtonField
                          checked={selectedUserType === "unpaid"}
                          onChange={() => handleRadioBtnChange("unpaid")}
                        />
                        <label>Un Paid</label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4">
                        <div className="input-group">
                          <div className="input-pad">
                            <Select
                              name="country_assign"
                              options={countryList}
                              value={search_country}
                              onChange={handleAssignCountryChangeByIndex}
                              placeholder="Select country"
                              className="dd-pad"
                              noOptionsMessage={() => "No Country Found"}
                              menuPlacement="bottom"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="input-group">
                          <div className="input-pad">
                            <Select
                              name="company_search"
                              options={companyOptions}
                              value={null}
                              onChange={handleCompanySelect}
                              onInputChange={handleAssignCompanyInputChange}
                              placeholder="Search Keywords"
                              className="dd-pad"
                              noOptionsMessage={() => "No Company Found"}
                              isLoading={memberOptLoader}
                              filterOption={customFilter}
                              blurInputOnSelect={false}
                              closeMenuOnSelect={false}
                              onMenuClose={handleMenuClose}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Assigned list: border aur space tabhi dikhega jab data ho */}
                    {size(assignedCompanyAndCountry) > 0 && (
                      <div className="assign-list pt-4 border-top">
                        {map(assignedCompanyAndCountry, (c, indx) => (
                          <div
                            key={c.value ?? indx}
                            className="row align-items-center mb-3"
                          >
                            <div className="col-md-4">
                              <Select
                                options={countryList}
                                value={
                                  c.assign_tomembers &&
                                  find(
                                    countryList,
                                    (option) =>
                                      option.country_id ===
                                      c.assign_tomembers.country_id,
                                  )
                                }
                                isDisabled={true}
                              />
                            </div>
                            <div className="col-md-5">
                              <Select
                                value={
                                  c.assign_tomembers && {
                                    label: c.assign_tomembers
                                      .member_unique_number
                                      ? `${c.assign_tomembers.company_name} - ${c.assign_tomembers.member_unique_number}`
                                      : c.assign_tomembers.company_name,
                                    value: c.assign_tomembers.id,
                                  }
                                }
                                isDisabled={true}
                              />
                            </div>
                            <div className="col-md-3 d-flex align-items-center justify-content-start gap-2 flex-nowrap assign-actions">
                              <ToolipsCustom
                                title={
                                  c.paid_status === "P"
                                    ? "Paid"
                                    : c.paid_status === "E"
                                      ? "Expired"
                                      : "Unpaid"
                                }
                                subtitle="status"
                                className={`status-count status-badge assign-item ${
                                  c.paid_status === "E"
                                    ? "status-expired"
                                    : c.paid_status === "P"
                                      ? "status-success"
                                      : "status-danger"
                                }`}
                                classNameChild="data-table-tooltiop"
                              >
                                {" "}
                              </ToolipsCustom>

                              <ToolipsCustom
                                title={c.inq_count}
                                subtitle="Total Inquires"
                                className="status-count status-total assign-item"
                                classNameChild="data-table-tooltiop"
                              >
                                {" "}
                              </ToolipsCustom>

                              <ToolipsCustom
                                subtitle="Delete"
                                className="fa-solid fa-trash-can icon-trash assign-item assign-delete border-0"
                                classNameChild="data-table-tooltiop"
                                onClick={() => handleRemoveCompany(indx)}
                              ></ToolipsCustom>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Submit Button */}
                    {size(assignedCompanyAndCountry) > 0 && (
                      <div className="inquiry-form-btn mt-4">
                        <ButtonAdminpanel
                          type="submit"
                          className="inq-form-btn"
                          disabled={isButtonDisabled}
                        >
                          Assign Inquiry
                        </ButtonAdminpanel>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getAllInquiries: (limit, current_page, filterObj) =>
    dispatch(getAllAdminInquiries(limit, current_page, filterObj)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  getCountryList: () => dispatch(getCountryList()),
  getCompaniesByCountry: (payload) =>
    dispatch(getCompaniesByCountry(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogisticInqViewPage);